import React, { Suspense } from 'react';
import SectionSaleDayWeekMonth from './sales/section-sale-day-week-month';
import SkeletonCardTotalList from '../sekeletons/skeleton-card-total';
import SectionSaleChart from './sales/section-sale-chart';
import { SkeletonYearLineChart } from '../sekeletons/skeleton-year-line-chart';
export default function SectionSale() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "sale mt-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-4xl mb-4"
    }, "\u58F2\u4E0A"), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 lg:grid-cols-4 gap-8"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonCardTotalList, {
            className: "grid-cols-1",
            length: 3
        })
    }, /*#__PURE__*/ React.createElement(SectionSaleDayWeekMonth, null)), /*#__PURE__*/ React.createElement("div", {
        className: "lg:col-span-3 bg-white shadow rounded-xl p-4"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonYearLineChart, null)
    }, /*#__PURE__*/ React.createElement(SectionSaleChart, null)))));
}
